import { z } from 'zod';
export const zAlertFilters = z.object({
    athleteIds: z.array(z.uuid()).nullish(),
    startDate: z.string().date().nullish(),
    endDate: z.string().date().nullish(),
    resolved: z.boolean().default(false),
});
//# sourceMappingURL=index.js.map